import { LoyaltyApi } from "@jti/rest-api";
import { type GetTiersResponseType } from "@jti/rest-api-types";

import { TAGS } from "../common/tags";
import type { LoyaltyApiBuilder } from "../loyaltyApi.types";

export type GetLoyaltyTiersEndpointResponse = GetTiersResponseType[];

export const getLoyaltyTiersEndpoint = (builder: LoyaltyApiBuilder) => ({
  getLoyaltyTiers: builder.query<GetLoyaltyTiersEndpointResponse, void>({
    queryFn: async () => {
      const loyaltyApi = LoyaltyApi.init();
      const response = await loyaltyApi.getTiers();

      return { data: response.data };
    },
    providesTags: [TAGS.LOYALTY_TIERS],
  }),
});
